import React from 'react';

// Material UI
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

/**
 * Select-all toggle control
 *
 * @param {Object} props Component props.
 * @param {() => void} props.onSelectAll Called when the button is clicked.
 * @param {boolean} props.selectAllState When true, the next action is "Select All"; when false, "Deselect All".
 * @param {string} [props.columnName='Has Access'] Human-readable column label for tooltip text.
 * @param {string} [props.itemType='items'] Human-readable item label for tooltip text.
 * @returns {JSX.Element}
 */
export default function SelectAllControl({ onSelectAll, selectAllState, columnName = 'Has Access', itemType = 'items' }) {
	const selectAllText = `Select "${columnName}" for all ${itemType} visible on this page`;
	const deselectAllText = `Deselect "${columnName}" for all ${itemType} visible on this page`;
	
	return (
		<Tooltip title={selectAllState ? selectAllText : deselectAllText}>
			<Button
				variant="contained"
				size="small"
				onClick={onSelectAll}
				startIcon={selectAllState ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
				sx={{
					marginLeft: 1,
					backgroundColor: 'white',
					color: 'primary.main',
					boxShadow: 'none',
					'&:hover': {
						backgroundColor: '#FCF7F7',
						boxShadow: 'none',
					},
				}}
			>
				{selectAllState ? 'Select All' : 'Deselect All'}
			</Button>
		</Tooltip>
	);
}